<template>
    <div>
        <Multiselect
                v-model="value"
                mode="tags"
                :options="options"
                :searchable="true"
                :placeholder="placeholder"
                @change="onChange"
        />
    </div>
</template>

<script>
    import axios from 'axios';
    import Url from '@/core/Url.js'
    import Multiselect from '@vueform/multiselect'

    export default {
        components: { Multiselect },
        name : 'user-country-selector',
        emits: ['update','error'],
        props: {
            selectedValues: {
                type: Array,
                default: []
            },
        },
        watch: {
            selectedValues: function(newVal, oldVal) {
                this.value  = newVal;
            },
            value: function(newVal, oldVal) {
                if (newVal.length == 0) {
                    this.placeholder = "Busca uno o varios paises";
                } else {
                    this.placeholder = "Cargando paises seleccionados..";
                }
            }
        },
        data() {
            return {
                value: [],
                options: {},
                placeholder: 'Busca uno o varios paises'
            }
        },
        methods: {
            buildOptions: function (countries) {
                let options = {};
                let option_key;
                for (let key in countries) {
                    option_key = countries[key]['id'];
                    options[option_key] = countries[key]['name'];
                }
                return options;
            },
            initCountries () {
                axios
                    .get(Url.getCountriesUrl())
                    .then(response => {
                        if (response.data.result) {
                            this.options = this.buildOptions(response.data.data);
                        } else {
                            this.emitError();
                        }
                    }).catch(error => {
                        this.emitError(error);
                    })
            },
            emitError () {
                this.$emit('error', "Se ha producido un error al consultar los paises.");
            },
            onChange (value) {
                this.$emit('update', value);
            },
        },
        created () {
            this.initCountries ();
        }
    }
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
